/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { APP } from 'Configs/App'
import LogIn from 'Containers/LogIn'
import SignUp from 'Containers/SignUp'
import ForgotPassword from 'Containers/ForgotPasswordPage'
import ResetPassword from 'Containers/ResetPassword'
import CreateCampaignWithoutSignup from 'Containers/CreateCampaignWithoutSignup'
import ExpiredLinkPage from 'Containers/ui/ExpiredLinkPage'
import InternalServerError from 'Containers/ui/InternalServerError'
import Registration from 'Containers/Registration'
import Tracks from 'Containers/Tracks/index'

import {
  signUpArtist,
  signUpCurator,
  forgotPass,
  reset,
  create,
  spotify,
  // review,
  errors,
  login,
  register,
  influencerBoard,
  internalServerError,
} from './routes'

const PublicComponents = () => (
  <Switch>
    <Route component={LogIn} exact path="/" />
    <Route component={LogIn} exact path={login} />
    <Route component={SignUp} exact path={signUpArtist} />
    <Route component={SignUp} exact path={signUpCurator} />
    <Route component={ForgotPassword} exact path={forgotPass} />
    <Route component={ResetPassword} exact path={`${reset}/:uuid`} />
    <Route component={ExpiredLinkPage} path={errors} />
    <Route component={InternalServerError} path={internalServerError} />
    <Route component={CreateCampaignWithoutSignup} exact path={create} />
    <Route component={Registration} exact path={register} />
    <Route component={Tracks} exact path={influencerBoard} />
    <Route
      component={() => {
        // @ts-ignore
        window.location.href = APP.SPOTIFY_AUTH_API
        return null
      }}
      path={spotify}
    />
    <Route component={LogIn} path="*" />
  </Switch>
)

export default PublicComponents
